import { render, staticRenderFns } from "./externalCourse-settings-basic.vue?vue&type=template&id=4f6de45e&"
import script from "./externalCourse-settings-basic.vue?vue&type=script&lang=ts&"
export * from "./externalCourse-settings-basic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports